import { NavMarker } from 'react-rhumb';
import PortalIdParser from 'PortalIdParser';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { Link } from 'foundations-components/transitional/components/Link';

// @ts-expect-error Untyped import
import { useActiveAnalyticsPage } from '../utils/useActiveAnalyticsPage';
// @ts-expect-error Untyped import
import { useAnalyticsPermissions } from '../utils/useAnalyticsPermissions';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PermissionRequiredPage = () => /*#__PURE__*/_jsx(Flex, {
  inlineSize: "600px",
  as: "div",
  justifySelf: "center",
  children: /*#__PURE__*/_jsxs(ErrorMessage, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "reports.errors.permissionsDeniedPage.title"
    }),
    illustration: "keys",
    "data-test-id": "permission-required-page",
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "reports.errors.permissionsDeniedPage.message"
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Link, {
      href: `/reports-list/${PortalIdParser.get()}/`,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "reports.errors.permissionsDeniedPage.help"
      })
    })]
  })
});
const AnalyticsAccessWrapper = ({
  children
}) => {
  const analyticsPermissions = useAnalyticsPermissions();
  const activePage = useActiveAnalyticsPage();
  const isVisible = analyticsPermissions.getIn([activePage, 'isVisible'], true);
  const accessAllowed = analyticsPermissions.getIn([activePage, 'accessAllowed'], true);
  if (!isVisible) {
    return null;
  }
  if (!accessAllowed) {
    return /*#__PURE__*/_jsx(NavMarker, {
      name: "ANALYTICS_PERMISSIONS_REQUIRED",
      children: /*#__PURE__*/_jsx(PermissionRequiredPage, {})
    });
  }
  return children;
};
export default AnalyticsAccessWrapper;